module.exports = __webpack_public_path__ + "img/BFZH.5e28d991.png";